

export const ExNyRoute = 1 
export const PrRoute =  '2' 
export const ExRoute = '3'
export const AcRoute = '4'
export const MiRoute = '5'
export const CoRoute = '6'
export const AcRouteB = '1009'
export const MiRouteB = '1010'

